import React, { useEffect, useState } from 'react'
import {
  useVoiceAssistant,
  useLocalParticipant,
  useParticipantTracks,
  useTrackTranscription
} from '@livekit/components-react'
import { Track } from 'livekit-client'

const LatencyDisplay: React.FC = () => {
  const { agentTranscriptions } = useVoiceAssistant()
  const { localParticipant } = useLocalParticipant()
  const audioTrack = useParticipantTracks([Track.Source.Microphone], localParticipant?.identity)[0]
  const { segments: userTranscriptions } = useTrackTranscription(audioTrack)

  const [timer, setTimer] = useState<number>(0)
  const [marginCount, setMarginCount] = useState<number>(0)
  const [lastMargin, setLastMargin] = useState<number>(0)
  const [errorMargin, setErrorMargin] = useState<number>(0)
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null)
  const [latencyHistory, setLatencyHistory] = useState<number[]>([])

  const [holder, setHolder] = useState<string>("")
  const [holderBot, setHolderBot] = useState<string | null>(null)

  // Start timer when userTranscriptions changes
  useEffect(() => {
    if (userTranscriptions.length > 0) {
      const text = userTranscriptions.map(e => e.text.split(' ').join(' ')).join(' ')
      if (holder !== text) {
        setHolder(text)

        if (intervalId) clearInterval(intervalId) // Clear previous timer if needed

        setErrorMargin((errorMargin + timer))
        setMarginCount(marginCount + 1)
        
        setTimer(0)

        const id = setInterval(() => {
          setTimer(prev => prev + 10)
        }, 10) // 10ms precision
        setIntervalId(id)
      }
    }
  }, [userTranscriptions, intervalId])

    // Stop timer when agentTranscriptions changes
  useEffect(() => {
    
    if (agentTranscriptions.length > 0 && intervalId) {
      const botText = agentTranscriptions[agentTranscriptions.length - 1]?.text
      if (botText !== undefined && holderBot !== null && botText !== holderBot) {
        setHolderBot(null)
        clearInterval(intervalId)
        setIntervalId(null)
        setLastMargin(marginCount !== 0 ? Math.round(errorMargin / marginCount) : 0)
        setErrorMargin(0)
        setMarginCount(0)
        setLatencyHistory(prev => [...prev, timer])
      }
      else {
        setHolderBot(botText ?? "")
      }

    }
  }, [agentTranscriptions, intervalId, timer])

  // Calculate average latency
  const averageLatency =
    latencyHistory.length > 0
      ? Math.round(latencyHistory.reduce((sum, t) => sum + t, 0) / latencyHistory.length)
      : 0
  const error = marginCount !== 0 ? Math.round(errorMargin / marginCount) : 0
  const fixedError = error === 0 ? Math.round(lastMargin / 2) : Math.round(error / 2)
  return (
    <div className="latency-display">
      <div>Latency: {timer} ms +- {fixedError} ms</div>
      {latencyHistory.length > 0 && <div>Average Latency: {averageLatency} ms</div>}
    </div>
  )
}

export default LatencyDisplay
